import banner from "./modules/banner";

export default {
  banner,
}




// WEBPACK FOOTER //
// ./src/store/banner/index.js